import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewEmi = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/emi_details/createEmi?`, data);
  return res.data;
};
export const createNewDisbursement = async (data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/emi_details/createdisbursment`,
    data
  );
  return res.data;
};
export const getAllDisbursements = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/emi_details/byCustomerId?customer_id=${data}`
  );
  return res.data;
};

export const getAllDisburseData = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}/filter/getAlldisbursement`,
    data
  );
  return res.data;
};
